import styled from "styled-components";

export const ContentContainer = styled.div`
    width: 100%;
    max-width: 100%;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    /* Phones (< sm): no fixed rail, so no left inset; reserve a little top room for the floating
       hamburger menu button. The rail + its inset return at sm and up. */
    padding-left: ${props => props?.removeLeftMargins ? 'unset' : '0px'};
    padding-right: 12px;
    padding-top: ${props => props?.removeLeftMargins ? 'unset' : '52px'};
    background: #FAFAFA;
    overflow-x: hidden;
    box-sizing: border-box;
    @media print {
        padding-left: 0px !important;
        padding-right: 0px !important;
        padding-top: 0px !important;
    }
    @media (min-width: 576px){
        padding-left: ${props => props?.removeLeftMargins ? 'unset' : '84px'};
        padding-right: 16px;
        padding-top: 0;
    }
    @media (min-width: 768px){
        padding-left: ${props => props?.removeLeftMargins ? 'unset' : '96px'};
        padding-right: 24px;
    }
`
